import { useContext, useEffect, useState } from "react";
import {
  Avatar,
  Box,
  Button,
  Grid,
  TextField,
  Typography,
  Paper,
  InputAdornment,
  CircularProgress,
  MenuItem,
  Autocomplete,
  IconButton,
  CardMedia,
  Stack,
  Modal,
  Slide,
} from "@mui/material";
import patientIcon from "../../../assets/Paziente.svg";
import RecurringBookingSummaryTable from "../RecurringBookingSummaryTable/RecurringBookingSummaryTable";
import { useFormRecurringBookingConclusion } from "../Context/formContext";
import searchIcon from "../../../assets/icons/SearchFilled.svg";
import { Controller, UseFormReturn } from "react-hook-form";
import {
  CommonFieldsData,
  confPianoTerapia,
  patientResearch,
} from "../../../networking";
import { RecurringBookingContext } from "../Context/RecurringBookingContextWrapper";
import RecurringBookingFormInterface, {
  RecurringBookingFormConfirm,
} from "../../../services/recurringBookingInterfaces";
import { AllertMessage } from "../../DoctorsList/Medint/MedintDetails/MedintDetails";
import RegionDataDetails from "../../AppointmentManagement/Calendar/RegionDataDetails";
import { IframeParams } from "../../AppointmentManagement/Calendar/ModalReservation/ModalReservation";
import IframeContainer from "../../IframeComponent/IframeContainer";
import anagraficaIcon from "../../../assets/Icons-desktop.svg";
import summaryImg from "../../../assets/Registration Confirmed.svg";
import { ModalReservationSummaryNew } from "../../AppointmentManagement/Calendar/ModalReservation/ModalSummary/ModalReservationSummary";
import SummaryTable from "../../AppointmentManagement/Calendar/ModalReservation/ModalSummary/DinamicalSummaryPages/SummaryTable";

const ModalSubmitResponse = (props: {
  openSummary: boolean;
  showRegionDataDetail: boolean;
  showSummary: () => void;
  handlePageReset: () => void;
}) => {
  return (
    <Modal open={props?.openSummary && !props?.showRegionDataDetail}>
      <Slide
        in={props?.openSummary && !props?.showRegionDataDetail}
        direction="down"
        timeout={800}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
          }}
        >
          <Box
            sx={{
              maxHeight: "170px",
              minHeight: "170px",
              minWidth: "300px",
              maxWidth: "500px",
              width: "100%",
              height: "100%",
              overflowY: "auto",
              padding: 2,
              backgroundColor: "white",
              borderRadius: "4px",
              boxShadow: 24,
            }}
          >
            <Grid
              container
              direction={"column"}
              justifyContent="center"
              alignItems={"center"}
            >
              <Grid item>
                <Typography
                  component="div"
                  color={"#024E88"}
                  sx={{
                    fontSize: "var(--font-size-125-rem, 20px)",
                    fontStyle: "normal",
                    fontWeight: 600,
                    lineHeight: "160%",
                    letterSpacing: "0.15px",
                  }}
                  fontWeight={"bold"}
                >
                  {`Prenotazione confermata!`}
                </Typography>
              </Grid>
              <Grid item>
                <CardMedia component="img" image={summaryImg} />
              </Grid>
              <Grid item sx={{ width: "100%" }}>
                <Grid
                  container
                  justifyContent="space-between"
                  alignItems="center"
                >
                  <Grid item>
                    <Button
                      variant="outlined"
                      onClick={props.showSummary}
                    >
                      Riepilogo prenotazione
                    </Button>
                  </Grid>
                  <Grid item>
                    <Button variant="contained" onClick={props.handlePageReset}>
                      Chiudi
                    </Button>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Box>
        </Box>
      </Slide>
    </Modal>
  );
};

const RecurringPatientDataForm = (props: {
  methods?: UseFormReturn<RecurringBookingFormInterface>;
  handlePatientFormOpening: Function;
  handleSummaryTableOpening: () => void;
  handlePageReset: () => void;
  viewSummary: boolean;
  numeroPrenotazione: string;
  iframeStatus: IframeParams;
  setIframeStatus: (value: IframeParams) => void;
}) => {
  const context = useContext(RecurringBookingContext);

  const methods = useFormRecurringBookingConclusion();
  const [dataFound, setDataFound] = useState<boolean>(true);
  const [dataLoad, setDataLoad] = useState<boolean>(false);
  const [dataLoaded, setDataLoaded] = useState<boolean>(false);
  const [selectedAnagrafica, setSelectedAnagrafica] = useState<any>(null);
  const [listaPazienti, setListaPazienti] = useState<any[]>([]);
  const [priorityText, setPriorityText] = useState("");
  const maxPriorityLength = 200;

  const watchCognomeNomePaziente = `${methods.watch("cognomePaziente") ?? ""} ${
    methods.watch("nomePaziente") ?? ""
  }`;
  const watchCognomePaziente = methods.watch("cognomePaziente");
  const watchNomePaziente = methods.watch("nomePaziente");
  const watchDataNascita = methods.watch("dataDiNascita");
  const watchCodiceFiscale = methods.watch("codiceFiscale");
  const watchTelefonoPaziente = methods.watch("telefonoPaziente");
  const watchEmail = methods.watch("email");
  const watchNumeroTessera = methods.watch("numeroTessera");
  const watchNotePrenotazione = methods.watch("notePrenotazione");

  const [showAllert, setShowAllert] = useState<boolean>(false);
  const [severity, setSeverity] = useState<string>("warning");
  const [message, setMessage] = useState<string>(
    "Confermare questa procedura?"
  );
  const [dataToSend, setDataToSend] = useState<any>(null);

  // Stato per il modale RegionDataDetails
  const [regionOpen, setRegionOpen] = useState(false);

  // Se il modale ritorna dati da usare nel body
  const [regionData, setRegionData] = useState<any>(null);

  // Apre il modale DOPO aver popolato il body nel context
  const handleOpenRegion = () => setRegionOpen(true);

  const [currentIdx, setCurrentIdx] = useState(0);

  // ids unici già calcolati altrove: assumo che in ciascun item ci sia IDAPPUNTAMENTO
  // unique è un array di stringhe (ID appuntamento)
  const unique = (context?.uniqueAppointmentIds ?? []) as string[];
  const curIdApp = String(unique?.[currentIdx] ?? ""); // ID corrente

  // Trova l'appuntamento completo a partire dall'ID corrente
  const curApp = (context?.selectedAppointments ?? []).find((a: any) => {
    const idA = String(a?.IDAPPUNTAMENTO ?? a?.id ?? "");
    return idA === curIdApp;
  });

  // Fallback multipli per i nomi campo (dipende da come arrivano dal backend)
  const hintSpec =
    curApp?.descrizioneSpecialita ??
    curApp?.DESCRIZIONESPECIALITA ??
    curApp?.SPECIALITA ??
    "";

  const hintPrest =
    curApp?.descrizionePrestazione ??
    curApp?.DESCRIZIONEPRESTAZIONE ??
    curApp?.PRESTAZIONE ??
    "";

  // quando CHIUDI/CONFERMI il modale, fai partire confPianoTerapia
  const handleRegionConfirm = (partial?: any) => {
    // Se il RegionDataDetails ha inviato { idAppuntamento, region }
    if (partial?.idAppuntamento && partial?.region) {
      context?.setConfermaPianoTerapiaBody((prev) => {
        const base = prev ?? {};
        const next = mergeRegionIntoBody(
          base,
          String(partial.idAppuntamento),
          partial.region
        );
        return next;
      });
    } else if (partial) {
      // fallback: eventuali altri pezzi che regiondata potesse mandare
      context?.setConfermaPianoTerapiaBody((prev) => ({ ...prev, ...partial }));
    }

    const more = currentIdx + 1 < unique.length;
    if (more) {
      setCurrentIdx((i) => i + 1);
    } else {
      setRegionOpen(false);
      setShowAllert(true);
    }
  };

  const fetchPatientData = async () => {
    const objectJsonRequest: CommonFieldsData = {
      ricerca: methods.getValues("anagraficaPaziente")?.trimEnd(),
      dataNascita: "",
    };

    setDataLoad(true);
    setDataFound(true);

    try {
      const objectJsonResponse = await patientResearch(objectJsonRequest);

      console.log("Risposta ricerca paziente:", objectJsonResponse);

      if (objectJsonResponse.data.dati.length < 1) {
        setDataFound(false);
      } else {
        setDataFound(true);
        setListaPazienti(objectJsonResponse.data.dati);
      }
    } catch (error) {
      console.error("Error fetching anagrafica:", error);
    } finally {
      setDataLoad(false);
    }
  };

  useEffect(() => {
    console.log(
      "Nuovo valore confermaPianoTerapiaBody:",
      context?.confermaPianoTerapiaBody
    );
  }, [context?.confermaPianoTerapiaBody]);

  useEffect(() => {
    console.log("Data paziente:", selectedAnagrafica);
  }, [selectedAnagrafica]);

  //Faccio un ciclo su tutti gli appuntamenti e recupero il primo idPrestazione che trovo per ogni prestazione
  const getFirstAppIdPerPrestazione = (arr: any[]) => {
    const seen = new Set<string>();
    const ids: string[] = [];
    const rows: any[] = [];

    for (const r of arr ?? []) {
      const idPrest = String(r?.IDPRESTAZIONE ?? "");
      const idApp = String(r?.IDAPPUNTAMENTO ?? r?.id ?? "");
      if (idPrest && idApp && !seen.has(idPrest)) {
        seen.add(idPrest);
        ids.push(idApp);
        rows.push(r);
      }
    }
    return { ids, rows };
  };

  const handlePatientData = () => {
    const { ids, rows } = getFirstAppIdPerPrestazione(
      context?.selectedAppointments ?? []
    );
    context?.setUniqueAppointmentIds(ids);
    context?.setUniqueAppointmentItems?.(rows);
    context?.setConfermaPianoTerapiaBody(
      (prev: RecurringBookingFormConfirm) => ({
        ...prev,
        keyStatus: "11",
        nomePaziente: watchNomePaziente,
        cognomePaziente: watchCognomePaziente,
        dataDiNascita: watchDataNascita ?? "",
        codiceFiscale: watchCodiceFiscale ?? "",
        telefonoPaziente: watchTelefonoPaziente ?? "",
        email: watchEmail ?? "",
        numeroTessera: watchNumeroTessera ?? "",
        notePrenotazione: watchNotePrenotazione ?? "",
        idAnapaz: selectedAnagrafica.IDPAZIENTE ?? "",
        numPrenotazione: props.numeroPrenotazione ?? "",
      })
    );
    // setShowAllert(true);
  };

  // Mappa le chiavi dal "region" del child ai nomi esatti della mia struttura prestazione
  const mapRegionToPrestazione = (currPrest: any, region: any) => ({
    // prendo il valore nuovo se esiste, altrimenti tengo l’esistente
    impegnativa: region.impegnativa ?? currPrest.impegnativa ?? "",
    dataImpegnativa: region.dataImpegnativa ?? currPrest.dataImpegnativa ?? "",
    IUP: region.iup ?? currPrest.IUP ?? "",
    diagnosi: region.diagnosi ?? currPrest.diagnosi ?? "",
    notePrestazione: region.notePrestazione ?? currPrest.notePrestazione ?? "",
    primoAccesso: region.primoAccesso ?? currPrest.primoAccesso ?? "",
    PIC: region.pic ?? currPrest.PIC ?? "",
    IDPai: region.idPai ?? currPrest.IDPai ?? "",
    tollGGAttesa: currPrest.tollGGAttesa ?? "",
    approfondimento: currPrest.approfondimento ?? "",

    protPIC: region.protPic ?? currPrest.protPIC ?? "",
    classePriorita: region.classePriorita ?? currPrest.classePriorita ?? "",
    tipoRicetta: region.tipoRicetta ?? currPrest.tipoRicetta ?? "",
    suggerita: region.prescrSuggerita ?? currPrest.suggerita ?? "",
    IURP: region.iurp ?? currPrest.IURP ?? "",
    provenienzaPaziente:
      region.provenienzaPaziente ?? currPrest.provenienzaPaziente ?? "",
    esenzione: region.esenzione ?? currPrest.esenzione ?? "",
    codPrestSISS: region.codPrestSISS ?? currPrest.codPrestSISS ?? "",
    codAgendaGP: region.codAgendaGP ?? currPrest.codAgendaGP ?? "",
    codNomenclRegionale:
      region.codNomenclatoreRegionale ?? currPrest.codNomenclRegionale ?? "",
    codCatalogoPrescr:
      region.codCatalogoPrescrizione ?? currPrest.codCatalogoPrescr ?? "",
    prescrittore: region.prescrittore ?? currPrest.prescrittore ?? "",
  });

  // Dato l'idAppuntamento, trova la prestazione che lo contiene e applica il merge
  const mergeRegionIntoBody = (
    body: any,
    idAppuntamento: string,
    region: Record<string, any>
  ) => {
    if (!body || !Array.isArray(body.prestazioni)) return body;

    const pIndex = body.prestazioni.findIndex((p: any) =>
      (p?.appuntamenti ?? []).some(
        (a: any) => String(a?.idAppuntamento) === String(idAppuntamento)
      )
    );
    if (pIndex < 0) return body; // non trovata: non faccio nulla

    const current = body.prestazioni[pIndex] ?? {};
    const mergedFields = mapRegionToPrestazione(current, region);

    const nextPrest = { ...current, ...mergedFields };
    const next = { ...body, prestazioni: [...body.prestazioni] };
    next.prestazioni[pIndex] = nextPrest;
    return next;
  };

  // Il metodo reset tradizionale non funziona poiché può essere di tipo diverso alla definizione dell'oggetto nei defaultValues
  const customResetOfPatientFields = () => {
    methods.setValue("cognomePaziente", "");
    methods.setValue("nomePaziente", "");
    methods.setValue("dataDiNascita", "");
    methods.setValue("email", "");
    methods.setValue("idAnapaz", "");
    methods.setValue("telefonoPaziente", "");
    methods.setValue("numeroTessera", "");
    methods.setValue("notePrenotazione", "");
    methods.setValue("codiceFiscale", "");
    methods.setValue("dataDiNascita", "");
  };

  const handleConfirmSendData = async () => {
    try {
      await confPianoTerapia(context?.confermaPianoTerapiaBody).then(
        (response) => {
          console.log(response);
          if (response.data.esito === "OK") {
            setSeverity("success");
            setMessage("Appuntamento/i registrati con successo");
          }
          if (response.data.esito === "KO") {
            setSeverity("error");
            setMessage(response.data.messaggio ?? "");
            setTimeout(() => {
              setShowAllert(false);
            }, 3000);
          }
        }
      );
    } catch (error) {
      console.error(
        "Errore durante la send del body di conferma terapia:",
        error
      );
    }
  };

  return (
    <>
      {props.iframeStatus.show ? (
        <>
          <IframeContainer
            // dataToSend={{ data: {}, tab: 0, sid: "" } as DTOIframe}
            iframeStatus={props.iframeStatus}
            setIframeStatus={props.setIframeStatus}
            idPaziente={selectedAnagrafica?.IDPAZIENTE}
          />
        </>
      ) : (
        <>
          {/* <AllertMessage
            showAllert={showAllert}
            setShowAllert={setShowAllert}
            severity={severity}
            message={message}
            dataToSend={dataToSend}
            submitFunction={handleConfirmSendData}
            showSummary={props.handleSummaryTableOpening}
          /> */}

          <ModalSubmitResponse
            openSummary={showAllert}
            showSummary={props.handleSummaryTableOpening}
            showRegionDataDetail={regionOpen}
            handlePageReset={props.handlePageReset}
          />

          {regionOpen && (
            <RegionDataDetails
              key={curIdApp}
              open={regionOpen}
              overrideIdPacada={curIdApp}
              isRecurring={true}
              hintsOverride={{
                specialita: hintSpec,
                prestazione: hintPrest,
              }}
              onConfirm={() => {
                handleRegionConfirm();
                handleConfirmSendData();
              }}
              onCancel={() => setRegionOpen(false)}
              handleClose={() => setRegionOpen(false)}
              selectedAppointmentsItem={curApp}
            />
          )}

          <RecurringBookingSummaryTable
            numeroPrenotazione={props.numeroPrenotazione}
            handleSummaryTableOpening={props.handleSummaryTableOpening}
            handlePageReset={props.handlePageReset}
            viewSummary={props.viewSummary}
            methodsMain={props?.methods}
            methodsDetail={methods}
          />
          <Box p={3}>
            <Typography variant="h6" gutterBottom>
              Dati Paziente
            </Typography>

            <Paper variant="outlined" sx={{ p: 3 }}>
              <Grid container spacing={3}>
                {/* Colonna Avatar */}
                <Grid item xs={12} md={3} textAlign="center">
                  <Avatar
                    src={patientIcon}
                    alt={watchCognomeNomePaziente}
                    sx={{
                      height: {
                        xs: 100,
                        sm: 140,
                        md: 160,
                      },
                      width: {
                        xs: 100,
                        sm: 140,
                        md: 160,
                      },
                      margin: "0 auto",
                      pt: 2,
                    }}
                  />
                  <Typography fontWeight="bold" mt={2}>
                    {watchCognomeNomePaziente}
                  </Typography>
                </Grid>

                {/* Colonna Form */}
                <Grid item xs={12} md={9}>
                  <Typography
                    variant="subtitle1"
                    fontWeight="bold"
                    gutterBottom
                  >
                    Inserimento Dati
                  </Typography>

                  <Grid container spacing={2}>
                    {/* Ricerca paziente */}
                    <Grid item xs={12} md={8}>
                      {!dataLoaded ? (
                        <Controller
                          name="anagraficaPaziente"
                          control={methods.control}
                          render={({ field }) =>
                            listaPazienti.length === 0 ? (
                              <TextField
                                {...field}
                                label={
                                  !dataFound
                                    ? "Nessun risultato trovato"
                                    : "Ricerca Paziente"
                                }
                                fullWidth
                                size="small"
                                placeholder="Nome, Cognome o Codice Fiscale"
                                value={field.value ?? ""}
                                onKeyDown={(e) => {
                                  if (e.key === "Enter") {
                                    e.preventDefault();
                                    if (field.value) {
                                      fetchPatientData();
                                      methods.setValue(
                                        "anagraficaPaziente",
                                        String(field.value)
                                      );
                                    }
                                  }
                                }}
                                InputProps={{
                                  endAdornment: (
                                    <InputAdornment
                                      position="end"
                                      sx={{ bgcolor: "transparent" }}
                                    >
                                      {dataLoad ? (
                                        <CircularProgress size={"1rem"} />
                                      ) : (
                                        <IconButton
                                          sx={{ height: 15, width: 15 }}
                                          onClick={(e) => {
                                            if (!field.value)
                                              e.preventDefault();
                                            else {
                                              fetchPatientData();
                                              methods.setValue(
                                                "anagraficaPaziente",
                                                String(field.value)
                                              );
                                            }
                                          }}
                                        >
                                          <Box
                                            component="img"
                                            sx={{ height: 24, width: 24 }}
                                            src={searchIcon}
                                            alt="Ricerca Anagrafica"
                                          />
                                        </IconButton>
                                      )}
                                    </InputAdornment>
                                  ),
                                }}
                              />
                            ) : (
                              <Autocomplete
                                autoComplete
                                autoHighlight
                                autoFocus
                                open={listaPazienti.length > 0}
                                options={listaPazienti || []}
                                getOptionLabel={(option: any) => {
                                  if (!option) return "";
                                  return `${option.COGNOME ?? ""} ${
                                    option.NOME ?? ""
                                  }
                                                  `.trim();
                                }}
                                onChange={(_, data) => {
                                  if (data) {
                                    methods.setValue(
                                      "idAnapaz",
                                      String(data.IDPAZIENTE)
                                    );
                                    methods.setValue(
                                      "cognomePaziente",
                                      String(data.COGNOME)
                                    );
                                    methods.setValue(
                                      "nomePaziente",
                                      String(data.NOME)
                                    );
                                    methods.setValue(
                                      "dataDiNascita",
                                      String(data.DATANASCPAZIENTE)
                                    );
                                    methods.setValue(
                                      "codiceFiscale",
                                      String(data.CODICEFISCALE)
                                    );
                                    methods.setValue(
                                      "email",
                                      String(data.EMAIL)
                                    );
                                    methods.setValue(
                                      "telefonoPaziente",
                                      String(data.TELEFONO)
                                    );
                                  }
                                  setSelectedAnagrafica(data);
                                  setListaPazienti([]);
                                }}
                                value={
                                  field.value && field.value.trim().length > 0
                                    ? field.value
                                    : methods.getValues("idAnapaz") ?? null
                                }
                                renderInput={(params) => (
                                  <TextField
                                    {...params}
                                    size="small"
                                    fullWidth
                                    label="Ricerca Paziente"
                                    placeholder="Nome, Cognome o Codice Fiscale"
                                    required
                                    sx={{ mb: 2 }}
                                  />
                                )}
                                renderOption={(props, option: any) => (
                                  <MenuItem {...props} key={option.IDPAZIENTE}>
                                    {`${option.COGNOME ?? ""} ${
                                      option.NOME ?? ""
                                    }`}
                                  </MenuItem>
                                )}
                              />
                            )
                          }
                        />
                      ) : (
                        <TextField
                          fullWidth
                          label="Ricerca Paziente"
                          placeholder="Nome, Cognome o Codice Fiscale"
                          size="small"
                          disabled
                          sx={{ mb: 2 }}
                          InputProps={{
                            startAdornment: (
                              <InputAdornment
                                position="end"
                                sx={{ bgcolor: "transparent", gap: 2 }}
                              >
                                <CircularProgress size={"1rem"} />
                                {` Caricamento.. `}
                              </InputAdornment>
                            ),
                          }}
                        />
                      )}
                    </Grid>
                    <Grid
                      item
                      xs={6}
                      md={4}
                      sx={{
                        display: "flex",
                        justifyContent: "flex-start",
                        alignItems: "center",
                      }}
                    >
                      {/* <Button variant="contained">Cerca</Button> */}
                      <Stack
                        direction="row"
                        display={"flex"}
                        justifyItems={"space-between"}
                        justifyContent={"space-between"}
                        spacing={1}
                      >
                        <Button
                          variant="outlined"
                          onClick={() => {
                            props?.setIframeStatus({
                              type: "insr",
                              data: props.iframeStatus?.data ?? {},
                              show: !props.iframeStatus?.show,
                            });
                          }}
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            gap: 1.25,
                            "& img": { width: 18, height: 18 },
                            "&:hover img": {
                              filter: "brightness(0) invert(1)",
                            },
                          }}
                        >
                          <CardMedia
                            component="img"
                            className="icon-img"
                            alt="icona anagrafica"
                            sx={{ mr: 1, height: 20, width: 20 }}
                            image={anagraficaIcon ?? <></>}
                          />
                          Aggiungi Anagrafica
                        </Button>

                        <Button
                          // sx={{ marginLeft: "20px" }}
                          variant="outlined"
                          onClick={customResetOfPatientFields}
                        >
                          Reset
                        </Button>
                      </Stack>
                    </Grid>

                    {/* Nome / Cognome */}
                    <Grid item xs={12} md={6}>
                      <Controller
                        name={`cognomePaziente`}
                        control={methods.control}
                        render={({ field }) => {
                          return (
                            <TextField
                              {...field}
                              size="small"
                              fullWidth
                              label="Cognome"
                              placeholder="Inserire Cognome"
                              value={field.value ?? ""}
                            />
                          );
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <Controller
                        name={`nomePaziente`}
                        control={methods.control}
                        render={({ field }) => {
                          return (
                            <TextField
                              {...field}
                              size="small"
                              fullWidth
                              label="Nome"
                              placeholder="Inserire Nome"
                              value={field.value ?? ""}
                            />
                          );
                        }}
                      />
                    </Grid>

                    {/* Data di nascita / Codice fiscale */}
                    <Grid item xs={12} md={6}>
                      <Controller
                        name={`dataDiNascita`}
                        control={methods.control}
                        render={({ field }) => {
                          return (
                            <TextField
                              {...field}
                              size="small"
                              fullWidth
                              disabled
                              label="Data di Nascita"
                              placeholder="MM/DD/YYYY"
                              type="date"
                              inputProps={{ max: "9999-12-31" }}
                              InputLabelProps={{ shrink: true }}
                              value={field.value ?? ""}
                            />
                          );
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <Controller
                        name={`codiceFiscale`}
                        control={methods.control}
                        render={({ field }) => {
                          return (
                            <TextField
                              {...field}
                              fullWidth
                              size="small"
                              disabled
                              label="Codice Fiscale"
                              placeholder="Inserire Codice Fiscale"
                              value={field.value ?? ""}
                            />
                          );
                        }}
                      />
                    </Grid>
                    {/* Telefono / Email */}
                    <Grid item xs={12} md={6}>
                      <Controller
                        name={`telefonoPaziente`}
                        control={methods.control}
                        render={({ field }) => {
                          return (
                            <TextField
                              {...field}
                              fullWidth
                              size="small"
                              label="Telefono"
                              placeholder="Inserire Telefono"
                              value={field.value ?? ""}
                            />
                          );
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <Controller
                        name={`email`}
                        control={methods.control}
                        render={({ field }) => {
                          return (
                            <TextField
                              {...field}
                              fullWidth
                              size="small"
                              label="Email"
                              placeholder="Inserire Email"
                              value={field.value ?? ""}
                            />
                          );
                        }}
                      />
                    </Grid>

                    {/* Numero Tessera / Primo Accesso */}
                    <Grid item xs={12} md={6}>
                      <Controller
                        name={`numeroTessera`}
                        control={methods.control}
                        render={({ field }) => {
                          return (
                            <TextField
                              {...field}
                              fullWidth
                              size="small"
                              label="Numero Tessera"
                              placeholder="Inserire Numero Tessera"
                              value={field.value ?? ""}
                            />
                          );
                        }}
                      />
                    </Grid>
                    <Grid
                      item
                      xs={6}
                      md={4}
                      sx={{
                        display: "flex",
                        justifyContent: "flex-start",
                        alignItems: "center",
                      }}
                    >
                      <Button
                        variant="contained"
                        disabled={selectedAnagrafica === null}
                        onClick={() =>
                          props?.setIframeStatus({
                            type: "tssr",
                            data: props.iframeStatus?.data ?? {},
                            show: !props.iframeStatus?.show,
                          })
                        }
                      >
                        {" "}
                        Gestione Tessera
                      </Button>
                    </Grid>

                    {/* Note*/}
                    <Grid item xs={12} md={12}>
                      <Controller
                        name={`notePrenotazione`}
                        control={methods.control}
                        render={({ field }) => {
                          return (
                            <TextField
                              fullWidth
                              size="small"
                              label="Note Prenotazione"
                              placeholder="Note prenotazione"
                              multiline
                              rows={4}
                              error={
                                field.value
                                  ? field.value.length > maxPriorityLength
                                  : false
                              }
                              value={field.value}
                              onChange={(e) => {
                                field.onChange(e);
                                setPriorityText(e.target.value);
                              }}
                              helperText={`(${
                                field.value ? field.value.length : 0
                              }/${200})`}
                            />
                          );
                        }}
                      />
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>

              {/* Pulsanti */}
              <Box display="flex" justifyContent="space-between" mt={4}>
                <Button
                  variant="outlinedError"
                  color="error"
                  onClick={() => props.handlePatientFormOpening(0)}
                >
                  Annulla
                </Button>
                <Button
                  variant="contained"
                  color="primary"
                  disabled={!methods.getValues("idAnapaz")}
                  onClick={() => {
                    getFirstAppIdPerPrestazione(
                      context?.selectedAppointments ?? []
                    );
                    methods?.handleSubmit(() => {
                      handlePatientData();
                      setCurrentIdx(0);
                      handleOpenRegion();
                    })();
                  }}
                >
                  Conferma Prenotazione
                </Button>
              </Box>
            </Paper>
          </Box>
        </>
      )}
    </>
  );
};

export default RecurringPatientDataForm;
